import { CheckCircle2, Sun } from "lucide-react";

const SERVICES = [
  "On-Grid Solar Systems",
  "Off-Grid Solar Systems",
  "Hybrid Solar Systems",
  "Solar Consultation",
  "Professional Installation",
  "Maintenance & Support",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="chapter-section about-chapter">
    <div className="site-container">
      <div className="chapter-label tt-reveal" data-testid="about-chapter-label"><span>01 / THE BELIEF</span><span>ROOTED IN KERALA. POWERED BY THE SUN.</span></div>
      <div className="about-layout">
        <div className="tt-reveal">
          <h2 className="eyebrow" data-testid="about-heading">ABOUT TECH THRISSUR</h2>
          <p className="manifesto-title" data-testid="about-manifesto">Better energy.<br />By design.<br /><span>For everyone.</span></p>
          <Sun className="manifesto-sun" size={92} strokeWidth={0.8} aria-hidden="true" />
        </div>
        <div className="about-story tt-reveal">
          <p className="about-lead" data-testid="about-description">We believe the best energy comes from above. And the best solutions start with understanding you.</p>
          <p>Tech Thrissur delivers end-to-end solar energy solutions for homes, businesses, industries and farms across Kerala. From a first conversation to installation and after-sales care, we make your switch to solar simple.</p>
          <p>Custom system design. High-quality components. Enphase microinverter technology. Every detail is engineered to make the most of your sunshine.</p>
          <div className="about-services">{SERVICES.map((s, i) => <div key={s} data-testid={`about-service-${i}`}><CheckCircle2 size={17} /><span>{s}</span></div>)}</div>
        </div>
      </div>
    </div>
  </section>
);
